var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "dialog-t" } }, [
    (_vm.isPrompt ? _vm.active : _vm.fActive)
      ? _c(
          "div",
          {
            ref: "con",
            staticClass: "vs-component con-vs-dialog con-vs-dialog-custom",
            class: [`vs-dialog-${_vm.color}`],
          },
          [
            _c("div", {
              staticClass: "vs-dialog-dark",
              on: {
                click: function ($event) {
                  return _vm.handleClose($event, true)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { ref: "dialogx", staticClass: "vs-dialog" },
              [
                _c(
                  "header",
                  { staticClass: "vs-dialog-header", style: _vm.styleHeader },
                  [
                    _c("div", { staticClass: "con-title-after" }, [
                      _c("span", {
                        staticClass: "after",
                        style: _vm.styleAfter,
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "dialog-title" }, [
                        _vm._v(_vm._s(_vm.title) + " "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "con-vs-tabs vs-tabs",
                          class: [
                            `vs-tabs-${_vm.tabColor}`,
                            `vs-tabs-position-${_vm.tabPosition}`,
                          ],
                        },
                        [
                          _c("div", { staticClass: "con-ul-tabs" }, [
                            _c(
                              "ul",
                              {
                                ref: "ul",
                                staticClass: "ul-tabs vs-tabs--ul",
                                class: [`ul-tabs-${_vm.tabAlignment}`],
                              },
                              _vm._l(
                                _vm.tabChildrenSlots,
                                function (child, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: child.label,
                                      ref: "li",
                                      refInFor: true,
                                      staticClass: "vs-tabs--li",
                                      class: {
                                        activeChild:
                                          _vm.tabChildActive ==
                                          (_vm.$slots.tabsAfter
                                            ? index + 1
                                            : index),
                                      },
                                      style:
                                        _vm.tabChildActive ==
                                        (_vm.$slots.tabsAfter
                                          ? index + 1
                                          : index)
                                          ? _vm.tabStyleTab
                                          : {},
                                      on: {
                                        mouseover: function ($event) {
                                          _vm.tabHover = true
                                        },
                                        mouseout: function ($event) {
                                          _vm.tabHover = false
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "vs-tabs--btn",
                                              style: _vm.tabStyleAlignIcon(
                                                child.icon
                                              ),
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.tabActiveChild(
                                                    _vm.$slots.tabsAfter
                                                      ? index + 1
                                                      : index
                                                  )
                                                },
                                              },
                                            },
                                            "button",
                                            child.$attrs,
                                            false
                                          ),
                                          child.$listeners
                                        ),
                                        [
                                          child.icon
                                            ? _c("vs-icon", {
                                                staticClass:
                                                  "vs-tabs--btn-icon",
                                                attrs: {
                                                  "icon-pack": child.iconPack,
                                                  icon: child.icon,
                                                  color: _vm.tabColor,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          child.label
                                            ? _c("span", [
                                                _vm._v(_vm._s(child.label)),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      child.tag
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "vs-tabs--btn-tag",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.tabClickTag(child)
                                                },
                                              },
                                            },
                                            [
                                              _c("vs-icon", {
                                                attrs: {
                                                  "icon-pack": child.iconPack,
                                                  icon: child.tag,
                                                  color: child.tagColor,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "line-vs-tabs",
                              style: _vm.tabStylex,
                            }),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.type == "alert"
                      ? _c("vs-icon", {
                          staticClass:
                            "vs-dialog-cancel vs-dialog-cancel--icon notranslate",
                          attrs: {
                            icon: _vm.closeIcon,
                            "icon-pack": _vm.iconPack,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleClose.apply(null, arguments)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vs-dialog-text" }, [
                  _c(
                    "div",
                    {
                      staticClass: "con-vs-tabs vs-tabs",
                      class: [
                        `vs-tabs-${_vm.tabColor}`,
                        `vs-tabs-position-${_vm.tabPosition}`,
                        _vm.tabClass,
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "con-slot-tabs" },
                        [
                          _vm._t("default"),
                          _vm._v(
                            "\n\t\t\t\t\t\t" + _vm._s(_vm.text) + "\n\t\t\t\t\t"
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._t(
                  "footer",
                  function () {
                    return [
                      (
                        _vm.buttonsHidden
                          ? false
                          : _vm.isPrompt || _vm.type == "confirm"
                      )
                        ? _c(
                            "footer",
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "vs-dialog-accept-button",
                                  attrs: {
                                    disabled:
                                      _vm.isValid == "none"
                                        ? false
                                        : !_vm.isValid,
                                    color: _vm.color,
                                    type: _vm.buttonAccept,
                                  },
                                  on: { click: _vm.acceptDialog },
                                },
                                [_vm._v(_vm._s(_vm.acceptText))]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-button",
                                {
                                  staticClass: "vs-dialog-cancel-button",
                                  attrs: {
                                    "text-color": "rgba(0,0,0,.5)",
                                    type: _vm.buttonCancel,
                                  },
                                  on: { click: _vm.cancelClose },
                                },
                                [_vm._v(_vm._s(_vm.cancelText))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "alert" && !_vm.isPrompt
                        ? _c(
                            "footer",
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "vs-dialog-accept-button",
                                  attrs: {
                                    color: _vm.color,
                                    type: _vm.buttonAccept,
                                  },
                                  on: { click: _vm.acceptDialog },
                                },
                                [_vm._v(_vm._s(_vm.acceptText))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  { dialog: this }
                ),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }